// renderUtils.js
import React from "react";
import styles from "./renderUtils.module.css";
import ObservationIcon from "../assets/microscope_96.png";
import DiagnosticReportIcon from "../assets/diagnostic-report-1.png";
import DocumentIcon from "../assets/doc-ref-1.png";
import MediaIcon from "../assets/media-1.png";
import SpecimenIcon from "../assets/specimen-1.png";
import PatientIcon from "../assets/Patient_Male_96.png";
import ProviderIcon from "../assets/Doctor_Male_96.png";
import OrganizationIcon from "../assets/world-health.png";
import EncounterIcon from "../assets/stethoscope_96.png";
import CommunicationIcon from "../assets/iris-logo.png";
import CareTeamIcon from "../assets/care-team-1.png";
import CarePlanIcon from "../assets/care-plan-1.png";
import ConditionIcon from "../assets/condition-1.png";
import ServiceRequestIcon from "../assets/service-request-1.png";
import QuestionnaireResponseIcon from "../assets/question-1.png";
import GoalIcon from "../assets/goal-1.png";
import PatientCard from "../cards/PatientCardExtended";
import ProviderCard from "../cards/ProviderCard";
import EncounterCard from "../cards/EncounterCard";
import ObservationCard from "../cards/ObservationCard";
import DiagnosticCard from "../cards/DiagnosticCard";
import DocumentReferenceCard from "../cards/DocumentReferenceCard";
import CommunicationCard from "../cards/CommunicationCardExtended";
import MediaCard from "../cards/MediaCard";
import SpecimenCard from "../cards/SpecimenCard";
import CarePlanCard from "../cards/CarePlanCard";
import ConditionCard from "../cards/ConditionCard";
import ServiceRequestCard from "../cards/ServiceRequestCard";
import QuestionnaireResponseCard from "../cards/QuestionnaireResponseCard";
import GoalCard from "../cards/GoalCard";

import { getIconForContentType } from "./getIconForContentType";
import { Badge } from "react-bootstrap";
import { FiArrowUpRight, FiArrowDownRight } from "react-icons/fi";
import { FaStar, FaRegClock } from "react-icons/fa";

const variants = {
    stat: "warning",
    routine: "info",
    urgent: "danger",
    asap: "warning"
};

/**
 * Maps a priority string to a Bootstrap variant.
 * @param {string} priority
 * @returns {string}
 */
function getPriorityVariant(priority) {
    return variants[priority?.toLowerCase()] || "secondary";
}


export const renderCommunicationAttachments = (comm = {}) => {
    //console.log("Rendering communicatin attachments......");
    const seen = {
        file: false,
        observation: false,
        document: false,
        diagnostic: false
    };

    const icons = [];

    const addIcon = (type, element) => {
        if (!seen[type]) {
            seen[type] = true;
            icons.push(
                <span key={type} style={{ marginLeft: "0.4rem" }}>
                    {element}
                </span>
            );
        }
    };

    // -----------------------------
    // Handle payload[]
    // -----------------------------
    (comm.payload || []).forEach((p) => {
        // 1) contentAttachment → FILES using helper
        if (p.contentAttachment) {
            const ct = p.contentAttachment.contentType || "";
            const title = p.contentAttachment.title || "";

            // Pass a combined string to help filename detection inside helper
            const detectString = `${ct} ${title}`.trim().toLowerCase();

            const icon = getIconForContentType(detectString, "contentAttachment");

            addIcon("file", icon);     // one generic file group (PDF, Word, etc.)
        }

        // 2) contentReference → resource icons
        if (p.contentReference?.reference) {
            const ref = p.contentReference.reference;

            if (ref.startsWith("Observation/")) {
                addIcon(
                    "observation",
                    <img
                        src={ObservationIcon}
                        alt="Observation Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }

            if (ref.startsWith("DocumentReference/")) {
                addIcon(
                    "document",
                    <img
                        src={DocumentIcon}
                        alt="Document Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }

            if (ref.startsWith("DiagnosticReport/")) {
                addIcon(
                    "diagnostic",
                    <img
                        src={DiagnosticReportIcon}
                        alt="Diagnostic Report Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("Media/")) {
                addIcon(
                    "media",
                    <img
                        src={MediaIcon}
                        alt="Media Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("Specimen/")) {
                addIcon(
                    "specimen",
                    <img
                        src={SpecimenIcon}
                        alt="Specimen Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("CarePlan/")) {
                addIcon(
                    "careplan",
                    <img
                        src={CarePlanIcon}
                        alt="CarePlan Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("Condition/")) {
                addIcon(
                    "condition",
                    <img
                        src={ConditionIcon}
                        alt="Condition Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("QuestionnaireResponse/")) {
                addIcon(
                    "questionnaireresponse",
                    <img
                        src={QuestionnaireResponseIcon}
                        alt="Questionnaire Response Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


            if (ref.startsWith("Goal/")) {
                addIcon(
                    "goal",
                    <img
                        src={GoalIcon}
                        alt="Goal Attachment"
                        style={{ width: 20, height: 20 }}
                    />
                );
            }


        }
    });

    // -----------------------------
    // Handle about[]
    // -----------------------------
    (comm.about || []).forEach((refObj) => {
        const ref = refObj.reference || "";

        if (ref.startsWith("Observation/")) {
            addIcon(
                "observation",
                <img
                    src={ObservationIcon}
                    alt="Observation Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }

        if (ref.startsWith("DocumentReference/")) {
            addIcon(
                "document",
                <img
                    src={DocumentIcon}
                    alt="Document Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }

        if (ref.startsWith("DiagnosticReport/")) {
            addIcon(
                "diagnostic",
                <img
                    src={DiagnosticReportIcon}
                    alt="Diagnostic Report Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }


        if (ref.startsWith("Media/")) {
            addIcon(
                "media",
                <img
                    src={MediaIcon}
                    alt="Media Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }


        if (ref.startsWith("Specimen/")) {
            addIcon(
                "specimen",
                <img
                    src={SpecimenIcon}
                    alt="Specimen Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }


        if (ref.startsWith("CarePlan/")) {
            addIcon(
                "careplan",
                <img
                    src={CarePlanIcon}
                    alt="CarePlan Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }


        if (ref.startsWith("Condition/")) {
            addIcon(
                "condition",
                <img
                    src={ConditionIcon}
                    alt="Condition Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }

        if (ref.startsWith("QuestionnaireResponse/")) {
            addIcon(
                "questionnaireresponse",
                <img
                    src={QuestionnaireResponseIcon}
                    alt="Questionnaire Response Attachment"
                    style={{ width: 20, height: 20 }}
                />
            );
        }
    });

    //console.log(icons);

    return icons.length > 0 ? <>{icons}</> : null;
};
export const getResourceIcon = (resourceType) => {
    //console.log(resourceType);

    if (!resourceType) return null;

    const type = resourceType.toLowerCase();

    if (type === "observation") {
        return <img src={ObservationIcon} alt="Observation" className={styles.resourceIcon} />;
    }

    if (type === "documentreference") {
        return <img src={DocumentIcon} alt="Document Reference" className={styles.resourceIcon} />;
    }

    if (type === "careplan") {
        return <img src={CarePlanIcon} alt="Care Plan" className={styles.resourceIcon} />;
    }

    if (type === "diagnosticreport") {
        return <img src={DiagnosticReportIcon} alt="Diagnostic Report" className={styles.resourceIcon} />;
    }

    if (type === "media") {
        return <img src={MediaIcon} alt="Media" className={styles.resourceIcon} />;
    }

    if (type === "specimen") {
        return <img src={SpecimenIcon} alt="Specimen" className={styles.resourceIcon} />;
    }

    if (type === "condition") {
        return <img src={ConditionIcon} alt="Condition" className={styles.resourceIcon} />;
    }

    if (type === "questionnaireresponse") {
        return <img src={QuestionnaireResponseIcon} alt="Questionnaire Response" className={styles.resourceIcon} />;
    }

    if (type === "goal") {
        return <img src={GoalIcon} alt="Goal" className={styles.resourceIcon} />;
    }


    return null;
};

export function renderPriorityBadge(priority) {
    const variant = getPriorityVariant(priority);

    return (
        <Badge bg={variant} className="mx-0" style={{ fontSize: "0.75rem" }}>
            {priority?.toUpperCase() || "N/A"}
        </Badge>
    );
}


export function renderReference(ref, label, onClick) {
    //console.log("renderReference called with:", { ref, label });

    if (!ref) return <span className="text-muted">N/A</span>;
    return (
        <button
            className="btn btn-link p-0"
            onClick={() => onClick?.(ref, label || ref)}
        >
            {label || ref}
        </button>
    );
};


export function renderPriority(priority) {
    if (!priority) return <Badge bg="secondary">Unknown</Badge>;

    const colorMap = {
        stat: "danger",
        asap: "warning",
        urgent: "info",
        routine: "success"
    };

    const level = priority.toLowerCase();
    const color = colorMap[level] || "secondary";

    return <Badge bg={color}>{priority.toUpperCase()}</Badge>;
}


// renderCard.js
export function renderCard(resource, extraProps = {}) {
    if (!resource || typeof resource !== "object") return null;

    const commonProps = {
        depth: 0,
        ...extraProps
    };

    switch (resource.resourceType) {

        case "Patient":
            return (
                <PatientCard
                    patientData={resource}
                    {...commonProps}
                />
            );

        case "Practitioner":
            return (
                <ProviderCard
                    practitionerData={resource}
                    {...commonProps}
                />
            );

        case "Encounter":
            return (
                <EncounterCard
                    encounterData={resource}
                    {...commonProps}
                />
            );

        case "Observation":
            return (
                <ObservationCard
                    observationData={resource}
                    title={
                        resource.code?.text ||
                        resource.code?.coding?.[0]?.display ||
                        "Observation"
                    }
                    {...commonProps}
                />
            );

        case "DiagnosticReport":
            return (
                <DiagnosticCard
                    reportData={resource}
                    title={
                        resource.code?.text ||
                        resource.code?.coding?.[0]?.display ||
                        "Diagnostic Report"
                    }
                    {...commonProps}
                />
            );

        //TODO: get rid of all these title props. They should come from the resource itself, not passed in (deprecated)
        case "DocumentReference":
            return (
                <DocumentReferenceCard
                    documentData={resource}
                    title={
                        resource.description ||
                        resource.content?.[0]?.attachment?.title ||
                        "Document Reference"
                    }
                    {...commonProps}
                />
            );

        case "Communication":
            return (
                <CommunicationCard
                    resource={resource}
                    {...commonProps}
                />
            );
        case "Media":
            return (
                <MediaCard
                    mediaData={resource}
                    {...commonProps}
                />
            );


        case "Specimen":
            return (
                <SpecimenCard
                    specimenData={resource}
                    {...commonProps}
                />
            );

        case "CarePlan":
            return (
                <CarePlanCard
                    carePlanData={resource}
                    {...commonProps}
                />
            );

        case "Condition":
            return (
                <ConditionCard
                    conditionData={resource}
                    {...commonProps}
                />
            );

        case "ServiceRequest":
            return (
                <ServiceRequestCard
                    serviceRequestData={resource}
                    {...commonProps}
                />
            );

        case "QuestionnaireResponse":
            return (
                <QuestionnaireResponseCard
                    qrData={resource}
                    {...commonProps}
                />
            );


        case "Goal":
            return (
                <GoalCard
                    goalData={resource}
                    {...commonProps}
                />
            );

        default:
            return (
                <div style={{ padding: "1rem", color: "#666" }}>
                    Unsupported resource type: <strong>{resource.resourceType}</strong>
                </div>
            );
    }
}

export const getDirectionIcon = (key) => {
    switch (key) {
        case "incoming": return <FiArrowDownRight style={{ color: "#dc3545", marginRight: "0.4rem" }} />;
        case "outgoing": return <FiArrowUpRight style={{ color: "#0d6efd", marginRight: "0.4rem" }} />;
        case "starred": return <FaStar style={{ color: "#ffc107", marginRight: "0.4rem" }} />;
        case "snoozed": return <FaRegClock style={{ color: "#6c757d", marginRight: "0.4rem" }} />;
        default: return null;
    }
};

export function getRAWResourceIcon(input) {
    if (!input) return null;

    let resourceType = null;

    // Case 1: FHIR reference string (e.g. "Patient/123")
    if (typeof input === "string") {
        resourceType = input.includes("/") ? input.split("/")[0] : input;
    }

    // Case 2: Hydrated FHIR resource
    if (typeof input === "object" && input.resourceType) {
        resourceType = input.resourceType;
    }

    if (!resourceType) return null;

    switch (resourceType.toLowerCase()) {
        case "patient":
            return PatientIcon;

        case "practitioner":
            return ProviderIcon;

        case "organization":
            return OrganizationIcon;

        case "encounter":
            return EncounterIcon;

        case "observation":
            return ObservationIcon;

        case "diagnosticreport":
            return DiagnosticReportIcon;

        case "documentreference":
            return DocumentIcon;

        case "media":
            return MediaIcon;

        case "specimen":
            return SpecimenIcon;

        case "communication":
            return CommunicationIcon;

        case "careteam":
            return CareTeamIcon;

        case "careplan":
            return CarePlanIcon;

        case "condition":
            return ConditionIcon;

        case "servicerequest":
            return ServiceRequestIcon;

        case "questionnaireresponse":
            return QuestionnaireResponseIcon;

        case "goal":
            return GoalIcon;


        default:
            return null;
    }
}

export function Field({ label, children }) {
    return (
        <div className="mb-1">
            <strong>{label}:</strong>{" "}
            {children ?? <span className="text-muted">N/A</span>}
        </div>
    );
}


export function SectionHeader({ children }) {
    return (
        <div className={styles.sectionHeader}>
            {children}
        </div>
    );
}
/**
 * renderCodeable
 * --------------
 * Renders a CodeableConcept with text + codings.
 */
export function renderCodeable(cc) {
    if (!cc) {
        return <span className="text-muted">N/A</span>;
    }

    return (
        <>
            {cc.text && <div>{cc.text}</div>}
            {cc.coding?.map((c, idx) => (
                <div key={idx} className="text-muted small ps-3">
                    {c.system ? `${c.system} → ` : ""}
                    {c.code} — {c.display}
                </div>
            ))}
        </>
    );
}








